<template>
  <InsightsChartsTab :charts="chartConfigurations" :filters="filters" :dateRange="dateRange" :pdfMode="pdfMode" />
</template>

<script>
import { CHART_NAMES, INSIGHTS_CHARTS } from '@/helpers/insightsCharts'

export default {
  name: 'InsightsOverviewTab',
  props: {
    filters: {
      type: Array,
      required: true,
      default: () => []
    },
    dateRange: {
      type: Array,
      required: true,
      default: () => []
    },
    pdfMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartConfigurations () {
      const chartTypes = [
        CHART_NAMES.CONTRACTS_PAID_AND_UNPAID,
        CHART_NAMES.CONTRACTS_ONGOING_AND_CLOSED,
        CHART_NAMES.CONTRACTS_SIGNED_AND_ADJUSTED_PRICES
      ]

      return chartTypes.map(chartName => ({
        name: chartName,
        componentName: INSIGHTS_CHARTS[chartName].component,
        defaultQuery: INSIGHTS_CHARTS[chartName].defaultQuery,
        defaultTimeDimension: INSIGHTS_CHARTS[chartName].defaultTimeDimension,
        chartWidth: INSIGHTS_CHARTS[chartName].chartWidth
      }))
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'))
    })
  }
}
</script>
